module.exports = __webpack_public_path__ + "img/pro_six_6.8577690e.jpg";